module.exports = __webpack_public_path__ + "fonts/HarmonyOS_Sans_SC_Medium.2b2b7c89.ttf";